<template>
  <div class="contractor">
    <Avatar
      class="contractor__avatar"
      :size="24"
      :name="contractor.name"
      :email="contractor.contractor_email"
      :pic="get(contractor, 'files_urls.avatar_thumbnail')"
    />
    <div>
      <div v-if="contractor.name" class="contractor__info spacex-4">
        <MarkText class="contractor__name" :text="contractor.name" :substring="searchContractor" />
        <span class="contractor__status">
          <!--          TODO: status-->
        </span>
      </div>
      <div class="contractor__contacts">
        <span v-if="contractor.email || contractor.contractor_email" class="contractor__email">
          {{ contractor.email || contractor.contractor_email }}
        </span>
        <span v-if="contractor.phone_number">
          <span class="contractor__phone">{{ contractor.phone_number }}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import MarkText from '@/components/ui/MarkText';
  import Avatar from '@/components/avatars/Avatar';
  import get from 'lodash.get';

  export default {
    name: 'Contractor',
    components: {
      MarkText,
      Avatar,
    },
    props: {
      contractor: {
        type: Object,
        required: true,
      },
      searchContractor: {
        type: String,
        default: '',
      },
    },
    methods: {
      get,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .contractor {
    display: flex;
    align-items: center;
  }

  .contractor__avatar {
    margin-right: 8px;
  }

  .contractor__info {
    display: flex;
  }

  .contractor__name {
    color: $grey900;
    font-weight: 500;
  }

  .contractor__contacts {
    > * + * {
      &:before {
        content: '·';
        margin-right: 4px;
        color: $grey500;
      }
    }
  }

  .contractor__status,
  .contractor__email,
  .contractor__phone {
    color: $grey500;
    font-weight: 500;
  }
</style>
